import React, { useState } from "react";
import { Link } from "react-router-dom";

const MenuItems = (props) => {
  const path = window.location.pathname;
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  const consultationServices = [
    { name: "Mobile App Development", path: "/consultation/mobile-app-development" },
    { name: "Web Application Development", path: "/consultation/web-application-development" },
    { name: "AI & Machine Learning", path: "/consultation/ai-machine-learning" },
    { name: "Cyber Security & VAPT", path: "/consultation/cyber-security-vapt" },
    { name: "DevSecOps & Platform Engineering", path: "/consultation/devsecops-platform-engineering" },
    { name: "CTO-as-a-Service", path: "/consultation/cto-as-a-service" },
    { name: "System Architecture & Solution Design", path: "/consultation/system-architecture-solution-design" },
    { name: "Product Discovery & MVP Development", path: "/consultation/product-discovery-mvp-development" },
    { name: "Digital Transformation", path: "/consultation/digital-transformation" },
    { name: "Performance Optimization & Scalability Engineering", path: "/consultation/performance-optimization-scalability" },
    { name: "Quality Assurance & Testing", path: "/consultation/quality-assurance-testing" },
    { name: "Ongoing Support & Engineering Partnership", path: "/consultation/ongoing-support-engineering-partnership" },
  ];

  const isConsultationActive = consultationServices.some(service => path === service.path);
  const isAboutActive = path === "/about-us" || path === "/about/projects";

  return (
    <React.Fragment>
      <li className={path === "/" ? "current-menu-item" : ""}>
        <Link to="/">Home</Link>
      </li>
      <li
        className={`menu-item-has-children ${isAboutActive ? "current-menu-item" : ""}`}
      >
        <Link to="/about-us">About</Link>
        <ul className="sub-menu">
          <li className={path === "/about-us" ? "current-menu-item" : ""}>
            <Link to="/about-us">About Us</Link>
          </li>
        </ul>
      </li>
      {/* <li className={path === "/services" ? "current-menu-item" : ""}>
        <Link to="/services">Services</Link>
      </li> */}
      <li
        className={`menu-item-has-children ${isConsultationActive ? "current-menu-item" : ""}`}
        onMouseEnter={() => setIsConsultationOpen(true)}
        onMouseLeave={() => setIsConsultationOpen(false)}
      >
        <Link to="/services">Services</Link>
        <ul className={`sub-menu ${isConsultationOpen ? "show" : ""}`}>
          {consultationServices.map((service, index) => (
            <li key={index} className={path === service.path ? "current-menu-item" : ""}>
              <Link to={service.path}>{service.name}</Link>
            </li>
          ))}
        </ul>
      </li>
      <li className={path === "/community" ? "current-menu-item" : ""}>
        <Link to="/community">Community</Link>
      </li>
      <li className={path === "/contact-us" ? "current-menu-item" : ""}>
        <Link to="/contact-us">Contact Us</Link>
      </li>
    </React.Fragment>
  );
};

export default MenuItems;
